import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import htmlToPdf from '../utils/htmlToPdf'
import VueBus from 'vue-bus'
import downLoadUrl from './downLoadUrl/index'

axios.defaults.baseURL = '/api'
axios.defaults.withCredentials = true
Vue.use(downLoadUrl)
Vue.use(VueAxios, axios)
Vue.use(VueBus)
const messages = ['success', 'warning', 'info', 'error']
messages.forEach(type => {
  ElementUI.Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
      options.duration = 2000
      options.showClose = true
    }
    options.type = type
    return ElementUI.Message(options)
  }
})
Vue.use(ElementUI)
Vue.use(htmlToPdf)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js